/*
  Cart drawer "(Save €X)" label — Sableau
  ------------------------------------------------------------
  The Essential Cart Drawer already renders a struck-through compare-at
  price and the sale price per line item. This script appends a green
  "(Save €X)" right after the sale price, computed from the two amounts
  that are already on screen, so it works in every market currency
  (EUR, SEK, NOK, DKK, GBP, ...) and re-applies after each drawer re-render.

  Scope: the drawer's own markup via its stable data-essential-cart-element
  hooks (line-item-regular-price / line-item-discounted-price).
*/
(function () {
  if (window.__sbCartSavingsLoaded) return;
  window.__sbCartSavingsLoaded = true;

  var STYLE = '.sb-save{color:#0a8a4a;font-weight:600;font-size:.85em;margin-left:.35em;white-space:nowrap}';

  // "€199,99" · "kr 1.113,07" · "1 113,07 kr" · "£85.00" · "SEK 1 158,00"
  var PRICE_RE = /^\s*(?:[^\d\s]{0,4}\s?)?\d[\d.,\s ]*(?:\s?[^\d\s]{0,4})?\s*$/;

  function leafText(el) {
    if (el.children.length) return null;
    var t = (el.textContent || '').replace(/ /g, ' ').trim();
    if (!t || t.length > 24 || !/\d/.test(t) || !PRICE_RE.test(t)) return null;
    return t;
  }

  function parseCents(str) {
    var num = str.replace(/[^\d.,]/g, '');
    var m = num.match(/^(.*?)([.,])(\d{2})$/);
    var intPart = (m ? m[1] : num).replace(/[.,]/g, '');
    var dec = m ? m[3] : '00';
    if (!intPart && !m) return null;
    return { cents: parseInt(intPart || '0', 10) * 100 + parseInt(dec, 10), decSep: m ? m[2] : null };
  }

  function formatLike(sample, cents) {
    var m = sample.match(/^(\D*?)(\d[\d.,\s ]*\d|\d)(\D*)$/);
    if (!m) return null;
    var prefix = m[1], numStr = m[2], suffix = m[3];
    var parsed = parseCents(numStr);
    var decSep = (parsed && parsed.decSep) || (numStr.indexOf(',') >= 0 ? ',' : '.');
    var thouSep = '';
    var head = numStr.replace(/[.,]\d{2}\s*$/, '');
    var t = head.match(/[.,\s ]/);
    if (t) thouSep = t[0];
    var whole = Math.floor(cents / 100);
    var frac = String(cents % 100);
    if (frac.length < 2) frac = '0' + frac;
    var ws = String(whole);
    if (thouSep) ws = ws.replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
    return prefix + ws + decSep + frac + suffix;
  }

  var ITEM = '[data-essential-cart-element="cart-drawer-item"]';
  var REG = '[data-essential-cart-element="line-item-regular-price"]';
  var DISC = '[data-essential-cart-element="line-item-discounted-price"]';
  var PROPS = '[data-essential-cart-element="line-item-properties"]';
  // The cart page renders the same line-item property as its own definition row.
  var PAGE_PROP = '.cart-items__property';

  function apply() {
    // 1) "(Save €X)" after the discounted price of every drawer line item.
    var items = document.querySelectorAll(ITEM);
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var reg = item.querySelector(REG);
      var disc = item.querySelector(DISC);
      if (!reg || !disc) continue;
      var regTxt = leafText(reg) || (reg.textContent || '').trim();
      var discTxt = leafText(disc) || (disc.textContent || '').trim();
      var a = parseCents(regTxt), b = parseCents(discTxt);
      var existing = disc.parentElement && disc.parentElement.querySelector(':scope > .sb-save');
      if (!a || !b || a.cents <= b.cents) { if (existing) existing.remove(); continue; }
      var label = formatLike(discTxt, a.cents - b.cents);
      if (!label) continue;
      var text = '(Save ' + label + ')';
      if (existing) { if (existing.textContent !== text) existing.textContent = text; continue; }
      var span = document.createElement('span');
      span.className = 'sb-save';
      span.textContent = text;
      disc.parentElement.insertBefore(span, disc.nextSibling);
    }
    /* 2) The "You save" property exists only so the saving reaches the checkout,
          which is the one screen we cannot add anything to. On the storefront it
          is noise: the drawer already shows a green "(Save X)" beside the price,
          and both the drawer and the cart page now carry the itemised savings
          block from assets/total-savings.js. Printing "\u2705 You save: 50%" as a
          raw property on top of that is a third statement of the same fact,
          stacked under the title where it reads like leftover debug text.
          Hidden on both surfaces; the property itself is untouched, so the
          checkout still receives it. */
    hideSavingProps(document.querySelectorAll(PROPS));
    hideSavingProps(document.querySelectorAll(PAGE_PROP));
  }

  function hideSavingProps(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.__sbHidden) continue;
      if (/You save\s*:/.test(el.textContent || '')) {
        el.style.display = 'none';
        el.__sbHidden = true;
      }
    }
  }

  window.__sbCartSavingsApply = apply;

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; try { apply(); } catch (e) {} }, 150);
  }

  function start() {
    var css = document.createElement('style');
    css.textContent = STYLE;
    (document.head || document.documentElement).appendChild(css);
    schedule();
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    // Drawer content is injected late / on open; a few timed passes catch it.
    var n = 0;
    var timer = setInterval(function () { schedule(); if (++n > 20) clearInterval(timer); }, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/*
  Checkout "You save" line — Sableau
  ------------------------------------------------------------
  Shopify's checkout (non-Plus) cannot show a compare-at price, but it does
  print line-item properties under the product. So every add-to-cart request
  from this storefront gets a "You save" property attached before it leaves the
  browser. Both fetch and XMLHttpRequest are wrapped so theme forms, sticky bar,
  quick-add and app upsells are all covered.

  The value is a PERCENTAGE, never a money amount, and that is deliberate.
  A line-item property is frozen text: it is written once at add-to-cart and
  Shopify never re-renders it. A shopper who adds to cart in EUR and then picks
  Norway in the checkout would keep reading "\u20ac8.99" next to a NOK total --
  reported live on 2026-08-20. Nothing client-side can fix that, because our
  scripts do not run inside the checkout.

  A percentage is a ratio of two amounts from the same response, so it is
  identical in every currency and cannot go stale. The absolute amount is still
  shown: Shopify's own TOTAL SAVINGS row prints it in the checkout's real
  currency, and the cart drawer prints "(Save X)" per line from the on-screen
  prices (see the first block in this file).
*/
(function () {
  if (window.__sbYouSaveLoaded) return;
  window.__sbYouSaveLoaded = true;

  var KEY = '\u2705 You save';
  var cache = {};

  function isCartAdd(url) {
    try { var u = new URL(String(url), location.origin); return /\/cart\/add(\.js)?$/.test(u.pathname); } catch (e) { return false; }
  }
  function variant(id) {
    if (!cache[id]) {
      cache[id] = fetch('/variants/' + id + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[id];
  }
  function labelFor(v) {
    if (!v || !v.compare_at_price || !v.price || v.compare_at_price <= v.price) return null;
    var pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
    if (!(pct > 0)) return null;
    return pct + '%';
  }

  // ---- body helpers -------------------------------------------------------
  function decorateFormData(fd) {
    if (fd.has('properties[' + KEY + ']')) return Promise.resolve(fd);
    var id = fd.get('id');
    if (!id) return Promise.resolve(fd);
    return variant(id).then(function (v) {
      var label = labelFor(v);
      if (label) fd.append('properties[' + KEY + ']', label);
      return fd;
    });
  }
  function decorateParams(str) {
    var p = new URLSearchParams(str);
    if (p.has('properties[' + KEY + ']')) return Promise.resolve(str);
    var id = p.get('id');
    if (!id) return Promise.resolve(str);
    return variant(id).then(function (v) {
      var label = labelFor(v);
      if (label) p.append('properties[' + KEY + ']', label);
      return p.toString();
    });
  }
  function decorateJson(str) {
    var data;
    try { data = JSON.parse(str); } catch (e) { return Promise.resolve(str); }
    var items = Array.isArray(data.items) ? data.items : (data.id ? [data] : []);
    var work = items.map(function (it) {
      if (!it || !it.id) return Promise.resolve();
      it.properties = it.properties || {};
      if (it.properties[KEY]) return Promise.resolve();
      return variant(it.id).then(function (v) { var label = labelFor(v); if (label) it.properties[KEY] = label; });
    });
    return Promise.all(work).then(function () { return JSON.stringify(data); });
  }
  function decorateBody(body) {
    if (!body) return Promise.resolve(body);
    if (typeof FormData !== 'undefined' && body instanceof FormData) return decorateFormData(body);
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return decorateParams(body.toString()).then(function (s) { return new URLSearchParams(s); });
    if (typeof body === 'string') {
      var t = body.trim();
      if (t.charAt(0) === '{') return decorateJson(t);
      if (/(^|&)id=/.test(t)) return decorateParams(t);
    }
    return Promise.resolve(body);
  }

  // ---- fetch --------------------------------------------------------------
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && isCartAdd(url) && init && init.body) {
          var self = this;
          return decorateBody(init.body).then(function (b) {
            var next = Object.assign({}, init, { body: b });
            return _fetch.call(self, input, next);
          }).catch(function () { return _fetch.call(self, input, init); });
        }
      } catch (e) {}
      return _fetch.apply(this, arguments);
    };
  }

  // ---- XMLHttpRequest ----------------------------------------------------
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__sbCartAdd = String(method).toUpperCase() === 'POST' && isCartAdd(url);
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (!this.__sbCartAdd || !body) return _send.apply(this, arguments);
      var xhr = this;
      decorateBody(body).then(function (b) { _send.call(xhr, b); }).catch(function () { _send.call(xhr, body); });
    };
  }
})();
